import { render, staticRenderFns } from "./projectServiceTotal.vue?vue&type=template&id=ca6d0fc4&scoped=true&"
import script from "./projectServiceTotal.vue?vue&type=script&lang=js&"
export * from "./projectServiceTotal.vue?vue&type=script&lang=js&"
import style0 from "./projectServiceTotal.vue?vue&type=style&index=0&id=ca6d0fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d0fc4",
  null
  
)

export default component.exports